import React from "react";
import SvgMirs from "components/presentation/SvgMirs";

export function ScoreContainer(props) {
  const { resultObj } = props;
  const winner = resultObj?.wlt === 'W' && <div className='score-winner'><SvgMirs className="mirsIcon score-winner" role="img" title='HeaderWinner' code='circle-check' /></div>
  const result = resultObj?.result;
  const dataH = resultObj?.extra?.totH;
  const dataX = resultObj?.extra?.totX;
  const dataS3 = resultObj?.extra?.totS3;
  const dataS = parseInt(resultObj?.extra?.totS);

  // const technique = props?.screen === undefined && resultObj?.wlt === 'W' && resultObj?.extra?.techCode ? resultObj?.extra?.techCode : ''
  let dataPenalties
  if (dataS > 0) {
    for (let i = 0; i < dataS; i++) {
      dataPenalties = <>{dataPenalties} <SvgMirs className="mirsIcon" role="img" title='LabelYCDesc' code='yellow-card' /> </>
    }
  } else if (dataH === '1' || dataX === '1' || dataS3 === '1') {
    dataPenalties = <> <SvgMirs className="mirsIcon" role="img" title='LabelRCDesc' code='red-card' /></>
  } else {
    dataPenalties = <> <SvgMirs className="mirsIcon" role="img" title='HeaderWCDesc' code='white-card' /></>
  }

  return (
    <div className='score-result-container d-flex flex-row justify-content-end align-self-center'>
      <div className="align-self-center  w-100 m-0 d-flex flex-nowrap align-items-center">
        <div className='score-result'>
          {winner}
        </div>
        <div className={`score-result  ${resultObj?.rCn ? resultObj?.rCn : 'fw-bold'}`}>
          {result}
        </div>
        <div className='score-cards-jud'>
          {dataPenalties}
        </div>
        {/* <div className='score-result'>
          {technique}
        </div> */}
      </div>
    </div>
  )
}
